import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, CONTACT, SHOP_URL } from "./nav";

export const Footer = () => (
  <footer className="relative border-t border-[#D4AF37]/20 bg-[#07080A]" data-testid="site-footer">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-16 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Logo className="h-20" />
        <p className="mt-6 max-w-md text-sm leading-relaxed text-[#C8C5BB]">
          JEM — Journey • Empower • Motivate is John E. Mason's educational and disability empowerment partnership program.
          It complements existing individualized services; it does not replace them.
        </p>
      </div>
      <nav aria-label="Footer" className="lg:col-span-3">
        <h2 className="label mb-5">Explore</h2>
        <ul className="space-y-2">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link to={n.to} className="text-sm text-[#E6E3DA] transition-colors hover:text-[#F3C649]" data-testid={`footer-nav-${n.id}`}>{n.label}</Link>
            </li>
          ))}
          <li>
            <a href={SHOP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-sm text-[#F3C649] transition-colors hover:text-[#FFE7A3]" data-testid="footer-shop">
              Shop — The Journey of Life <ArrowUpRight size={14} aria-hidden="true" /><span className="sr-only"> (opens in a new tab)</span>
            </a>
          </li>
        </ul>
      </nav>
      <div className="lg:col-span-4">
        <h2 className="label mb-5">Contact John</h2>
        <ul className="space-y-3 text-sm">
          <li><a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-3 text-[#F9F8F6] hover:text-[#F3C649]" data-testid="footer-email"><Mail size={16} aria-hidden="true" className="text-[#F3C649]" />{CONTACT.email}</a></li>
          <li><a href={`tel:${CONTACT.tel}`} className="inline-flex items-center gap-3 text-[#F9F8F6] hover:text-[#F3C649]" data-testid="footer-phone"><Phone size={16} aria-hidden="true" className="text-[#F3C649]" />{CONTACT.phone}</a></li>
        </ul>
        <Link to="/contact" className="btn-gold mt-8" data-testid="footer-cta">Discuss a JEM Partnership</Link>
      </div>
    </div>
    <div className="border-t border-white/10">
      <p className="mx-auto max-w-[1400px] px-5 py-6 text-xs text-[#A9A598] sm:px-8">
        © {new Date().getFullYear()} JEM — Journey • Empower • Motivate. A John E. Mason program.
      </p>
    </div>
  </footer>
);
